import script from "./UserRoleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRoleList.vue?vue&type=script&setup=true&lang=ts"

import "./UserRoleList.vue?vue&type=style&index=0&id=ad92bc06&lang=css"
import "./UserRoleList.vue?vue&type=style&index=1&id=ad92bc06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad92bc06"]])

export default __exports__